/**
 * The `location` object must have the properties { pathname }.
 * You can get it from `useLocation()`.
 * @param {*} param0 object with { location }
 * @returns 
 */
function redirectOnLogout({ location, query }) {
    const searchParams = new URLSearchParams(location.search);
    if (query) {
      Object.entries(query).forEach(([key, value]) => {
        searchParams.set(key, value);
      });
    }
    const search = searchParams.toString(); // empty if no parameters
    const optionalSearch = search.length > 0 ? `?${search}` : "";
    const optionalHash = location.hash ?? "";
    const entryMap = {
        "/portal": `/entry/portal${optionalSearch}${optionalHash}`,
        "/commerce": `/entry/commerce${optionalSearch}${optionalHash}`,
        "/admin": `/entry/admin${optionalSearch}${optionalHash}`,
        "/activities/run": `/entry/activity${optionalSearch}${optionalHash}`,
        "/marketplace": "/entry/portal", // redirect to entry/portal which will redirect unauthenticated users to marketplace
        "/profile": "/entry/portal",
        "/design": "/entry/portal", // because currently there is nothing in URL to indicate which activity design to return to
        "/preview": "/entry/portal", // because currently there is nothing in URL to indicate which activity preview to return to
        "/readonly": "/entry/portal", // because currently there is nothing in URL to indicate which activity preview to return to
        "/setup": "/setup", // for sys-admins only, if they followed a link from internal handbook to setup page, return there after sign-in
      };
      const checkEntryMap = (loc) => {
        return entryMap[loc.pathname];
      };
      const startsWithList = [ "/accept/", "/users/" ]; // if path starts with this string, return to path; for example /accept/:id, /users/:id
      const checkStartsWithList = (loc) => {
        for (let i = 0; i < startsWithList.length; i += 1) {
          if (loc.pathname.startsWith(startsWithList[i])) {
            return loc.pathname;
          }
        }
        return null;
      };
      const redirectLocation = checkEntryMap(location) ?? checkStartsWithList(location) ?? "/";
      console.log(`redirectOnLogout signout from ${location.pathname} to ${redirectLocation}`);
      return redirectLocation;
}

export { redirectOnLogout };